import React from 'react';
import {
    DetailsList,
    SelectionMode,
    IColumn,
    ISelection,
    IObjectWithKey,
    IDetailsListProps,
    DetailsListLayoutMode,
    IDetailsListStyles
} from '@fluentui/react/lib/DetailsList';
import { ArrayService } from '../../services/ArrayService';

export interface ISortableListProps extends IDetailsListProps {
    className?: string;
    columns: IColumn[];
    items: IObjectWithKey[];
    selectionMode?: SelectionMode;
    selection?: ISelection;
}

export interface ISortableListState {
    Columns: IColumn[];
    Items: IObjectWithKey[];
}

export class SortableList extends React.Component<ISortableListProps, ISortableListState> {

    constructor(props: ISortableListProps) {
        super(props);
        this.state = { Columns: [], Items: [] };
    }

    public render(): React.ReactElement {
        const { props, state } = this;

        // custom styles for header

        const detailsListStyles: Partial<IDetailsListStyles> = {
            root: {
                border: '1px solid rgb(166, 166, 166)',  // light gray border
                //borderRadius: '4px',          // optional: rounded corners
                boxSizing: 'border-box',   // prevents scroll caused by border
                overflowX: 'hidden',   // hides horizontal scrollbar
                selectors: {
                    '.ms-DetailsHeader': {
                        backgroundColor: '#f3f3f3 !important',
                        height: '30px !important',
                    },
                    '.ms-DetailsHeader-cell': {
                        backgroundColor: '#f3f3f3 !important',
                        lineHeight: '20px !important',
                        verticalAlign: 'center',
                    },
                    '.ms-DetailsHeader-cellWrapper': {
                        height: '30px !important',
                        paddingTop: '0 !important',
                        paddingBottom: '0 !important',
                    },
                    '.ms-DetailsHeader-cellName': {
                        fontSize: '16px !important',  // bigger text
                        fontWeight: 500,              // bold
                    },
                    //add hover style for rows
                    '.ms-DetailsRow:hover': {
                        backgroundColor: '#fcfcfc !important', // very light gray
                    },
                },
            },
        };

        return (
            <DetailsList
                {...props}
                className={props.className}
                selectionMode={props.selectionMode != null ? props.selectionMode : SelectionMode.single}
                selection={props.selection}
                setKey={"state.SortableItems"}
                columns={state.Columns}
                items={state.Items}
                layoutMode={DetailsListLayoutMode.justified}
                //layoutMode={DetailsListLayoutMode.fixedColumns} //another option to fix horizontal scroll
                styles={detailsListStyles}
            />
        );
    }

    //#region Form initialisation

    public componentDidMount(): void {
        this.setColumns(this.props.columns);
        this.setState({ Items: this.cloneArray(this.props.items) });
    }

    public componentDidUpdate(prevProps: ISortableListProps): void {
        if (JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)) {
            this.setState({ Items: this.cloneArray(this.props.items) });
        }
        if (JSON.stringify(prevProps.columns) !== JSON.stringify(this.props.columns)) {
            this.setColumns(this.props.columns);
        }
    }

    private setColumns = (cols: IColumn[]) => {
        const _cols = cols.map(c => ({ ...c }));
        _cols.forEach(c => c.onColumnClick = this._onColumnClick);
        this.setState({ Columns: _cols });
    }

    private cloneArray = (arr: IObjectWithKey[]) => arr.map(a => ({ ...a }));

    //#endregion

    //#region Form infrastructure

    private _onColumnClick = (_, column: IColumn): void => {
        const { Columns, Items } = this.state;
        let newItems: IObjectWithKey[] = this.cloneArray(Items);
        const newColumns: IColumn[] = Columns.map(c => ({ ...c }));
        const currColumn: IColumn = newColumns.find(currCol => column.key === currCol.key)!;
        newColumns.forEach(newCol => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        newItems = ArrayService.sortObjectArray(newItems, currColumn.fieldName || '', currColumn.isSortedDescending);
        this.setColumns(newColumns);
        this.setState({ Items: newItems });
    }

    //#endregion
}
